<template>

<div id="PeekioIcon">

  <a target="_blank" href="https://peekio.no/">
    <img :src="require('../../assets/img/peekio.png')">
  </a>

</div>

</template>

<script>
export default {
  name: "PeekioIcon"
}
</script>
